fx.ns("shared.popups", class BasePersonPopup extends fx.components.Popup{
    
    constructor(data, personAsset)
    {
        super(data);

        this.personAsset = personAsset || fx.get("assets").personAdvice;

        this.contentWidth = 300;
        this.contentHeight = 300;

        this._footerButtons = [];
    }

    get personImage()
    {
        return this.circlesBox.person;
    }

    create()
    {
        super.create();

        this._innerContent = new fx.components.VBox("inner-content");
        super.addChild( this._innerContent, {width : "100%", top : (window.fx.browser.isMobile || window.fx.browser.isTablet) ? "center" : 0});

        this.circlesBox = new shared.component.Person(fx.get("assets").personAsset);
       
        if (window.fx.browser.isMobile || window.fx.browser.isTablet)
		    this.addChild(this.circlesBox, {width:200, height : 200, top :  0, left : "center"});
        else
            super.addChild(this.circlesBox, {width:200, height : 200, top : -90, left : "center"});
    }

    postCreate()
    {
        this._footerButtonsContainer = new fx.components.HBox({className : "buttons", align : "center"});
        this.addChild( this._footerButtonsContainer, {bottom : (fx.browser.isMobile || fx.browser.isTablet) ? 0 : undefined ,  left : "center"});

        for(let i = 0; i < this._footerButtons.length; i++)
        {
            this._footerButtonsContainer.addChild( this._footerButtons[i].child, 
                                                    {   width : (fx.browser.isMobile || fx.browser.isTablet) ? (100/this._footerButtons.length) + "%" : this._footerButtons[i].viewport.width,
                                                        height : this._footerButtons[i].viewport.height, 
                                                        top : this._footerButtons[i].viewport.top, 
                                                        left : this._footerButtons[i].viewport.left, 
                                                        bottom : this._footerButtons[i].viewport.bottom, 
                                                        right : this._footerButtons[i].viewport.right
                                                    }
                                                );
        }
    }

    onReady()
    {
        super.onReady();

        if (this.closeBtn)
            this.on("click", this.onClose, this.closeBtn);
    }

    addFooterChild(child, viewport)
    {
        if (child == "close")
        {
            this.closeBtn = child =  new fx.components.Button({label : fx.text("Fermer"), type : "filled"});
            viewport = {width : 200};
        }
        
        this._footerButtons.push({child : child, viewport : viewport});

        if (this.initialized)
        {
            this._footerButtonsContainer.addChild( child, 
                                                    {   width : (fx.browser.isMobile || fx.browser.isTablet) ? (100/this._footerButtons.length) + "%" : viewport.width,
                                                        height : viewport.height, 
                                                        top : viewport.top, 
                                                        left : viewport.left, 
                                                        bottom : viewport.bottom, 
                                                        right : viewport.right
                                                    }
                                                );

            if (fx.browser.isMobile || fx.browser.isTablet)
            {
                for(let i = 0; i < this._footerButtons.length; i++)
                    this._footerButtonsContainer.getChildAt(i).width = (100/this._footerButtons.length) + "%";
                
            }
        }
        
     
    }

    addChild(child, viewport)
    {
        viewport = viewport || {};
        viewport.top = viewport.top || 0;
        viewport.top += ((fx.browser.isMobile || fx.browser.isTablet) ? 0 : 120);

        this._innerContent.addChild( child, viewport);
    }


    get contentHeight()
    {
        return this._contentHeight;
    }

    set contentHeight(val)
    {
        this._contentHeight = val + ((fx.browser.isMobile || fx.browser.isTablet) ? 0 : 100);

        if (this.initialized)
        {
            this._contentContainer.height(this._contentHeight);
            this.updateDisplay();
        }
    }
});